/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { $wrapNodeInElement } from "@lexical/utils"
import {
  $createParagraphNode,
  $insertNodes,
  $isRootOrShadowRoot,
  COMMAND_PRIORITY_EDITOR,
  createCommand
} from "lexical"
import { useEffect, useState } from "react"
import * as React from "react"

import {
  $createPollNode,
  createPollOption,
  PollNode
} from "../../nodes/PollNode"
import Button from "../../ui/Button"
import { DialogActions } from "../../ui/Dialog"
import TextInput from "../../ui/TextInput"

export const INSERT_POLL_COMMAND = createCommand("INSERT_POLL_COMMAND")

export function InsertPollDialog({ activeEditor, onClose }) {
  const [question, setQuestion] = useState("")

  const onClick = () => {
    activeEditor.dispatchCommand(INSERT_POLL_COMMAND, question)
    onClose()
  }

  return (
    <>
      <TextInput label="Question" onChange={setQuestion} value={question} />
      <DialogActions>
        <Button disabled={question.trim() === ""} onClick={onClick}>
          Confirm
        </Button>
      </DialogActions>
    </>
  )
}

export default function PollPlugin() {
  const [editor] = useLexicalComposerContext()
  useEffect(() => {
    if (!editor.hasNodes([PollNode])) {
      throw new Error("PollPlugin: PollNode not registered on editor")
    }

    return editor.registerCommand(
      INSERT_POLL_COMMAND,
      payload => {
        const pollNode = $createPollNode(payload, [
          createPollOption(),
          createPollOption()
        ])
        $insertNodes([pollNode])
        if ($isRootOrShadowRoot(pollNode.getParentOrThrow())) {
          $wrapNodeInElement(pollNode, $createParagraphNode).selectEnd()
        }

        return true
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor])
  return null
}
